import { render, staticRenderFns } from "./HotspotColorPicker.vue?vue&type=template&id=e494ba88&scoped=true"
import script from "./HotspotColorPicker.vue?vue&type=script&lang=js"
export * from "./HotspotColorPicker.vue?vue&type=script&lang=js"
import style0 from "./HotspotColorPicker.vue?vue&type=style&index=0&id=e494ba88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e494ba88",
  null
  
)

export default component.exports